import { render, staticRenderFns } from "./LoadProducts.vue?vue&type=template&id=11c4bf70&scoped=true&"
import script from "./LoadProducts.vue?vue&type=script&lang=js&"
export * from "./LoadProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c4bf70",
  null
  
)

export default component.exports